module.exports = __webpack_public_path__ + "media/images/amenities_icons/nearby_airbnb-b0fb5bcfe8005eeaf61a0225a1429500.svg";